import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { Button, Modal, Radio } from 'antd';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Sticky from 'react-sticky-el';
import { IconSave } from './iconEmpty';

import { useDpiaContext } from '../dpia.context';
import classNames from 'classnames';

export const BtnSave = ({ ...props }) => {
    const { t, i18n } = useTranslation(['translation', 'dpia']);
    const {
        ref,
        refSave,
        status,
        setselectStatus,
        setSetselectStatus,
        wizard,
    } = useDpiaContext();

    const [open, setOpen] = useState(false);

    
    const handleOk = () => {
        ref?.current?.click();
        setOpen(false);
    };

    const handleCancel = () => {
        setOpen(false);
    };

    const checkValidate = () => {
        ref?.current?.click();
    };
    return (
        <>
            <div
                style={{ borderLeft: '1px solid #DBDBDB' }}
                className="ml-6 flex items-center"
            >
                <Button
                    ref={refSave}
                    onClick={() => checkValidate()}
                    className="text-[#1890FF]"
                    type="link"
                    loading={props.loading}
                >
                    <span className="underline">{t('Save')}</span>
                </Button>
                <span>{t('to save the latest changes')}</span>
            </div>
            <div
                style={{ borderLeft: '1px solid #DBDBDB' }}
                className="ml-6 flex items-center"
            >
                <Button
                    onClick={() => wizard?.SW?.goToStep(9)}
                    className="text-[#1890FF]"
                    type="link"
                >
                    <span className="underline">{t('Overview')}</span>
                </Button>
                <span>{t('Data entry')}</span>
            </div>
            <Modal
                className="_modal"
                centered
                closable={false}
                open={open}
                onCancel={handleCancel}
                footer={false}
                width={400}
            >
                <div className="text-center m-auto">
                    <IconSave />
                    <div className="text-1xl font-semibold">
                        {t('Save data')}
                    </div>
                    <div>
                        {t('What is the current status of DPIA', {
                            ns: 'dpia',
                        })}
                    </div>
                    {status?.length > 0 && (
                        <Radio.Group
                            value={setselectStatus}
                            className="space-y-2 my-4"
                            onChange={({ target: { value } }) => {
                                setSetselectStatus(value);
                            }}
                        >
                            {status?.map((status) => (
                                <Radio
                                    className={classNames(
                                        'border-solid border rounded-lg p-2 shadow-md w-80',
                                        {
                                            'border-[#DBDBDB]':
                                                setselectStatus !==
                                                status.statusId,
                                            'border-[#7B67FB]':
                                                setselectStatus ===
                                                status.statusId,
                                        }
                                    )}
                                    key={status.statusId}
                                    value={status.statusId}
                                    style={{ lineHeight: '32px' }}
                                >
                                    {i18n.language === 'en'
                                        ? status.nameEn
                                        : status.nameTh}
                                </Radio>
                            ))}
                        </Radio.Group>
                    )}
                    <div className="py-4">
                        <Button
                            ghost
                            type="primary"
                            size="large"
                            className="px-10 mr-2"
                            onClick={handleCancel}
                        >
                            {t('Cancel')}
                        </Button>
                        <Button
                            onClick={handleOk}
                            type="primary"
                            size="large"
                            className="px-10"
                        >
                            {t('Submit')}
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export function StepsButton({ previous, next }) {
    const { t } = useTranslation(['translation', 'dpia']);
    return (
        <Sticky
            mode="bottom"
            boundaryElement=".block_"
            stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
        >
            <div className="flex items-center space-x-2">
                <Button type="default" size="large" onClick={previous}>
                    <ArrowLeftOutlined /> {t('policy.PreviousStep')}
                </Button>
                <Button
                    onClick={next}
                    size="large"
                    type="primary"
                    className="px-8"
                >
                    {t('policy.NextStep')} <ArrowRightOutlined />
                </Button>
                <BtnSave />
            </div>
        </Sticky>
    );
}
